import React from 'react';
import cn from 'classnames';
import useFormattedPrice from '@hooks/useFormattedPrice';
import { PriceGroup } from '@adapters/bigcommerce/types/product';
import { FEATURE_FLAG_PDP_PRICE_CONTAINER } from '@config/feature-flag';
import ComparisonPriceContainerView from './ComparisonPriceContainerView';
import styles from './ProductPrice.module.scss';

interface ProductPriceProps {
  price: PriceGroup;
  className?: string;
  showOriginalPrice?: boolean;
}

const ProductPrice = ({
  price,
  className,
  showOriginalPrice = true,
}: ProductPriceProps) => {
  const { priceString, originalPriceString } = useFormattedPrice(price);

  if (FEATURE_FLAG_PDP_PRICE_CONTAINER) {
    return (
      <ComparisonPriceContainerView
        price={price}
        priceString={priceString}
        originalPriceString={originalPriceString}
        className={className}
        showOriginalPrice={showOriginalPrice}
      />
    );
  }

  return (
    <div className={cn(styles.priceContainer, className)}>
      <span className={styles.actualPrice}>{priceString}</span>
      {showOriginalPrice && originalPriceString && (
        <span className={styles.basePrice}>{originalPriceString}</span>
      )}
    </div>
  );
};

export default ProductPrice;
